import { RootState } from '@algoan/dashboard/store/store';
import { AsyncStatus } from '@algoan/dashboard/model';
import { isAccountsLoadingSelector, isTransactionsLoadingSelector } from '@algoan/dashboard/store/selectors';

export const widgetLoadingSelector = (state: RootState): boolean => {
  const isAccountsLoading = isAccountsLoadingSelector(state);
  const isTransactionsLoading = isTransactionsLoadingSelector(state);

  return (
    isAccountsLoading ||
    isTransactionsLoading ||
    state.analysis.analysesFetchingStatus === AsyncStatus.PENDING ||
    state.dashboardPage.refreshInProgress === AsyncStatus.PENDING
  );
};
